/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Header_Read_DocsInputs */

const en_platform_header_read_docs = /** @type {(inputs: Platform_Header_Read_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read docs`)
};

const zh_hans1_platform_header_read_docs = /** @type {(inputs: Platform_Header_Read_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`阅读文档`)
};

const pt_br2_platform_header_read_docs = /** @type {(inputs: Platform_Header_Read_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ler a documentação`)
};

const es_platform_header_read_docs = /** @type {(inputs: Platform_Header_Read_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leer la documentación`)
};

const fr_platform_header_read_docs = /** @type {(inputs: Platform_Header_Read_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lire la documentation`)
};

const de_platform_header_read_docs = /** @type {(inputs: Platform_Header_Read_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doku lesen`)
};

const ru_platform_header_read_docs = /** @type {(inputs: Platform_Header_Read_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Читать документацию`)
};

const it_platform_header_read_docs = /** @type {(inputs: Platform_Header_Read_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leggi la documentazione`)
};

/**
* | output |
* | --- |
* | "Read docs" |
*
* @param {Platform_Header_Read_DocsInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const platform_header_read_docs = /** @type {((inputs?: Platform_Header_Read_DocsInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Header_Read_DocsInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_platform_header_read_docs(inputs)
	if (locale === "pt-BR") return pt_br2_platform_header_read_docs(inputs)
	if (locale === "es") return es_platform_header_read_docs(inputs)
	if (locale === "fr") return fr_platform_header_read_docs(inputs)
	if (locale === "de") return de_platform_header_read_docs(inputs)
	if (locale === "ru") return ru_platform_header_read_docs(inputs)
	if (locale === "it") return it_platform_header_read_docs(inputs)
	return en_platform_header_read_docs(inputs)
});